module.exports = __webpack_public_path__ + "static/media/bathTemp.3ba1d0bd.svg";